import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "../../../ui/Credit/Button/Button";
import { Item } from "../../../ui/Credit/Item/Item";
import { Container } from "../../../ui/Credit/Container/Container";
import { Image } from "../../../ui/Credit/Image/Image";

const Text = styled.div`
  font-weight: ${(props) => props.fw === 'b' && 'bold' || 'lighter'};
  margin: ${(props) => props.m || "16px 0"};
  font-size: ${(props) => props.fs}px;
  color: ${(props) => props.color || "#000"};
`;

const Title = styled.h1`
  font-size: 46px;
  font-weight: bolder;
  margin-top: 24px;
  position: relative;

  &:before {
    content: "";
    width: 200px;
    height: 30px;
    background-color: mediumpurple;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.3;
    z-index: -1;
  }
`;

const Box = styled.div`
  width: 100%;
  margin-top: 32px;
  padding: 32px 0 16px 0px;
  background-color: rgba(147, 112, 219, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CreditMain = () => {
  const contentArr = [
    "🙆‍♀️ 대상자 기준이 확~ 넓어졌어요!",
    "💸 500만원에 추가 50만원까지 확대 되었어요!",
    "💳 국민내일배움카드 누구나 쉽게 신청할 수 있어요!",
    "⏰ 10명 중 9명이 발급 받고, 0원 교육 듣고 있어요!",
  ];

  return (
    <Container className="App-main">
      <div className="App-layout">
        <Image width={90} src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/logo/learningfit-logo.png`} />
        <Text fs={22} m={'24px 0'}>
          미루지 말고, 지금 바로
          <br />
          <b>국카찬스를 받으세요!</b>
        </Text>
        <Image width={248} src={`https://meamrxrtxnna6744001.cdn.ntruss.com/contents/resources/img/credit-check-list/1.png`} />
        <Title>국카찬스</Title>
        <Text fs={28} color={"#6c15a7"} m={'24px 0'} fw={'b'}>
          최대 550만원 혜택!
        </Text>
        <Text fs={18}>
          내가 받을 수 있는
          <br />
          국비지원금은 얼마일까요?
        </Text>
        <Link to={"/credit/question"}>
          <Button width={328} bg={"#6c15a7"} color={"#fff"}>
            국카찬스 10초만에 확인 GO &gt;
          </Button>
        </Link>
        <Text fs={15}>* 개인정보 처리방침에 동의합니다.</Text>
        <Box>
          <Text fs={18} m={"0"}>
            미루지 말고, 지금 바로
          </Text>
          <Text fs={22} m={"0 0 16px"}>
            받아야 하는 이유는?
          </Text>

          {contentArr.map((elem, idx) => {
            return <Item key={idx} fs={13}>{elem}</Item>;
          })}
        </Box>
      </div>
    </Container>
  );
}

export default CreditMain;